(()=>{
const q=(r,s)=>[...r.querySelectorAll(s)];
const vis=e=>e.offsetParent!==null||getComputedStyle(e).position==='fixed';
function swipe(el,prev,next){let x0=null,y0=null;el.addEventListener('pointerdown',e=>{x0=e.clientX;y0=e.clientY});el.addEventListener('pointerup',e=>{if(x0===null)return;const d=e.clientX-x0,dy=e.clientY-y0;x0=null;if(Math.abs(d)>40&&Math.abs(d)>Math.abs(dy)){e.preventDefault();(d<0?next:prev)()}});el.addEventListener('click',e=>{if(el.dataset.hmMoved){e.preventDefault();delete el.dataset.hmMoved}},true)}
q(document,'.hm [data-hm-fade]').forEach(b=>{
  const s=q(b,':scope>.hm-s'),dots=q(b,'[data-hm-dot]');let i=0,t=null;
  function go(n){i=(n+s.length)%s.length;s.forEach((x,k)=>{x.classList.toggle('is-on',k===i);x.setAttribute('aria-hidden',k!==i)});dots.forEach((d,k)=>d.setAttribute('aria-current',k===i))}
  q(b,'[data-hm="next"]').forEach(a=>a.onclick=e=>{e.preventDefault();go(i+1);run()});
  q(b,'[data-hm="prev"]').forEach(a=>a.onclick=e=>{e.preventDefault();go(i-1);run()});
  dots.forEach((d,k)=>d.onclick=()=>{go(k);run()});
  swipe(b,()=>{go(i-1);run()},()=>{go(i+1);run()});
  const ms=+b.dataset.hmAuto||0;
  function run(){if(!ms)return;clearInterval(t);t=setInterval(()=>go(i+1),ms)}
  if(ms){b.addEventListener('mouseenter',()=>clearInterval(t));b.addEventListener('mouseleave',run)}
  go(0);run();
});
q(document,'.hm [data-hm-car]').forEach(w=>{
  const track=w.querySelector('.hm-track'),n=track.children.length,l=w.closest('.hm-l')||w.parentElement;let i=0;
  function go(k){i=(k+n)%n;const g=parseFloat(getComputedStyle(track).columnGap)||0;track.style.transform='translateX('+(-i*(w.getBoundingClientRect().width+g))+'px)'}
  q(l,'[data-hm="prev"]').forEach(a=>a.onclick=()=>go(i-1));
  q(l,'[data-hm="next"]').forEach(a=>a.onclick=()=>go(i+1));
  swipe(w,()=>go(i-1),()=>go(i+1));
  addEventListener('resize',()=>go(i));
});
})();
